module.exports = __webpack_public_path__ + "img/01.525b1a4f.png";